import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { Store } from '@sama/app-state';
import { map } from 'rxjs/operators';
import { ToggleButton } from '../../../../../../cross-team-shared/components/toggle-button-group/toggle-button-group.component';
import { VideoStore } from '../../../../../../outputs/annotation/video/state/video-store';
import { VideoOutput } from '../../../../../../team-apis/otterdam/outputs/video-output';
import {
  OutputInfo,
  outputInfoStoreToken,
} from '../../../../../h3ml/state/output-info';

@Component({
  selector: 'h3-ml-assist',
  templateUrl: './ml-assist.component.html',
  styleUrls: ['./ml-assist.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MlAssistComponent {
  selectedRange$ = this.videoStore('mlAssistRange').$.pipe(
    map((mlAssistRange) => mlAssistRange.toString()),
  );
  rangeButtons: ToggleButton[];
  private mlExtrapolationOptionsState =
    this.outputInfoStore.state().output.meta.ml_extrapolation_options;

  constructor(
    @Inject(outputInfoStoreToken)
    private outputInfoStore: Store<OutputInfo<VideoOutput>>,
    private videoStore: VideoStore,
  ) {
    this.rangeButtons = [
      {
        label: 'Off',
        value: '0',
      },
      ...this.mlExtrapolationOptionsState.ranges.map((range) => ({
        label: range.toString(),
        value: range.toString(),
      })),
    ];

    this.setDefaultMlRange();
  }

  setMlAssistRange(range: string) {
    this.videoStore('mlAssistRange').set(+range);
  }

  private setDefaultMlRange() {
    const defaultRange = this.mlExtrapolationOptionsState.default_range;
    this.videoStore('mlAssistRange').set(defaultRange);
  }
}
